import * as React from "react";
import _ from "lodash";
import { useEffect } from "react";
import { initializeGoogleAnalytics, trackPageView } from "./analytics";
import { render } from "react-dom";
import { createHashHistory } from "history";
import { Provider } from "react-redux";
import Routes from "../member/routes";
import mixpanel from "mixpanel-browser";
import {
  initializeMixpanelTracking,
  setMixpanelUser,
} from "../shared/trackEvents/mixpanelTracking";

import buildStore from "../member/redux/buildStore";

import environmentVariables from "../shared/enviromentVariables/index.js.erb";
import ErrorView from "../member/components/ErrorView";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

const history = createHashHistory();
const store = buildStore({ ...window.__PRELOADED_STATE__ });
let isGAInitialized = false;
let release_state = environmentVariables.release_state;
let isMixpanelInitialized = false;

const OpenDirector = ({ token, user, releaseState }) => {
  window.mixpanel = mixpanel;

  useEffect(() => {
    // Google Analytics
    if (!isGAInitialized) {
      initializeGoogleAnalytics();
      isGAInitialized = true;
    }

    // Mixpanel
    if (!isMixpanelInitialized) {
      initializeMixpanelTracking(token, releaseState);
      isMixpanelInitialized = true;
    }

    setMixpanelUser(user);

    const handleHashChange = _.debounce(() => {
      trackPageView(window.location);
    }, 500);

    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  return (
    <Provider store={store}>
      <Routes history={history} />
    </Provider>
  );
};

document.addEventListener("DOMContentLoaded", () => {
  const div = document.createElement("div");
  div.setAttribute("class", "open-director-frontend");
  const rootElement = document.body.appendChild(div);
  const apiKey = environmentVariables.bugsnag_key || "INVALID-API-KEY";
  const releaseState = environmentVariables.release_state;
  const userEmail =
    window.__PRELOADED_STATE__.users.user.email ||
    "public-user@opendirector.com.au.invalid";

  Bugsnag.start({
    apiKey: apiKey,
    plugins: [new BugsnagPluginReact()],
    release_state: releaseState,
    user: { email: userEmail },
  });

  const ErrorBoundary = Bugsnag.getPlugin("react").createErrorBoundary(React);

  render(
    <ErrorBoundary FallbackComponent={ErrorView}>
      <OpenDirector
        token={environmentVariables.mixpanel_token}
        user={window.__PRELOADED_STATE__?.users?.user}
        releaseState={releaseState}
      />
    </ErrorBoundary>,
    rootElement
  );
});

// hack turbo to stop and only open streamObserver for badges to work
Turbo.navigator.delegate.stop();
Turbo.navigator.delegate.streamObserver.start();
